var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultEmptyImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F2BA4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.417 11.75H19.583a7.833 7.833 0 00-7.833 7.833v54.834a7.833 7.833 0 007.833 7.833h54.834a7.833 7.833 0 007.833-7.833V19.583a7.833 7.833 0 00-7.833-7.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.291 39.167a5.875 5.875 0 100-11.75 5.875 5.875 0 000 11.75zM82.25 58.75L62.668 39.167 19.584 82.25"
  }))));
}

export default SvgDefaultEmptyImage;